/* eslint-disable no-unused-vars */
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TransactionPayloadType } from 'storeTypes'
import { PaymentItem } from './PaymentItem'

interface PaymentRowProps {
    transactionList: TransactionPayloadType[]
    dateReceived: string
}

export const PaymentRow = ({
    transactionList,
    dateReceived
}: PaymentRowProps) => {
    const { t } = useTranslation()

    return (
        <div className="list--row">
            <p className="list--row--title">
                {t('fullDateMonthYear', {
                    date: new Date(dateReceived || '')
                })}
            </p>
            {transactionList.map((transaction, idx) => (
                <PaymentItem transaction={transaction} key={idx} />
            ))}
        </div>
    )
}
